import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ModalAction } from '../modal-action';

@Component({
    selector: 'eig-edit-modal-action',
    templateUrl: './edit-modal-action.component.html',
    styleUrls: ['../modal-action.component.scss']
})
export class EditModalActionComponent implements OnInit {
    @Input() updateButtonName = 'button_name.update';
    @Input() updateThenContinueButtonName = 'button_name.update_then_return';
    @Output() onUpdate = new EventEmitter<ModalAction>();
    constructor() {}

    ngOnInit(): void {}

    update() {
        this.onUpdate.emit(ModalAction.Update);
    }

    updateAndReturn() {
        this.onUpdate.emit(ModalAction.UpdateAndReturn);
    }
}
